<template>
  <div class="skeketon">
    <div class="skeketon-header">
      <div class="skeketon-header-right">
      </div>
    </div>
    <div class="skeketon-conter">
      <div class="skeketon-conter-list" v-for="i in 6" :key="i">
        <div class="skeketon-conter-list-left"></div>
        <div class="skeketon-conter-list-right">
          <p></p>
          <p></p>
          <p> </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
<style lang='scss' scoped>
.skeketon {
  @include skeletonBlink();
  height: calc(100vh - 50px);
  overflow: hidden;
  position: relative;
  &-header {
    @include wh(100%, 45px);
    background: var(--APP_skeleton_color);
    display: flex;
    @include center();
    &-right {
      @include wh(300px, 30px);
      @include center();
      border-radius: 4px;
        background: var(--APP_skeleton_background_color);
    }
  }
  &-conter {
    background: #fff;
    padding: 0 10px;
    padding-bottom: 27px;
    &-list {
      @include wh(100%, 125px);
      padding-top: 15px;
      box-sizing: border-box;
      display: flex;
      &-left {
        @include wh(100px, 100px);
        background: var(--APP_skeleton_color);
        margin-right: 20px;
        border-radius: 4px;
      }
      &-right {
        border-bottom: 1px solid #eeeeee;
        height: 100%;
        p {
          border-radius: 2px;
          margin-bottom: 10px;
          background: var(--APP_skeleton_color);
        }
        p:nth-child(1) {
          @include wh(230px, 15px);
        }
        p:nth-child(2) {
          @include wh(230px, 15px);
        }
        p:nth-child(3) {
          @include wh(165px, 15px);
        }
      }
    }
  }
}
</style>
